<!--
================================================================================

<pop-up-window
          v-if="showPopup"
          @back="showPopup = !showPopup"
          header="Create New Salary Structure">

          <template v-slot:content>
            <create-salary-structure></create-salary-structure>
          </template>

</pop-up-window>

================================================================================ -->


<template>
  <div>
    <div class="modal" :class="{modalbg: isModal}">
      <div class="modal-content" :class="{animated: animate, fadeInUp: animate}" :style="customStyle" ref="modalBox">
        <div class="top-bar">
          <img @click="back" src="@/assets/path-2-copy.png" v-if="useDefaultHeader" />
          <span class="heading_new" v-if="useDefaultHeader">{{ header }}</span>
          <slot name="header">
          </slot>
        </div>
        <div class="popup-window-content">
          <slot name="content">
          </slot>
          <slot name="bottom">
            <div>

            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      header: {
        type: String
      },
      btnText: {
        type: String
      },
      popupType: {
        type: String,
        default: "Success"
      },
      popupHeaderMessage: {
        type: String,
        default: "Success"
      },
      closable: {
        type: Boolean,
        default: false
      },
      useDefaultHeader: {
        type: Boolean,
        default: true
      },
      animate: {
        type: Boolean,
        default: false
      },
      isModal: {
        type: Boolean,
        default: true
      },
      customStyle: {
        type: String,
        default: null
      }
    },
    components: {
    },
    mounted() {
      if(this.animate) {
        this.$root.$el.style.position = "absolute";
        this.$root.$el.style.overflow = "hidden";
        this.$root.$el.style.height = "100%";

        // When PopUpMessage is mounted but not displayed on screen, i.e. when PopUpMessage used with v-show
        // Not Required now, PopUpMessage is used with v-if
        // if (this.$el.style.display == "none") {
        //   this.$root.$el.style.position = "static";
        //   this.$root.$el.style.overflow = "visible";
        //   this.$root.$el.style.height = "auto";
        // }
      }
    },
    beforeDestroy() {
      if(this.animate) {
        this.$root.$el.style.position = "static";
        this.$root.$el.style.overflow = "visible";
        this.$root.$el.style.height = "auto";
      }
    },
    methods: {
      back() {
        if(this.animate) {
          this.$refs.modalBox.classList.remove('fadeInUp');
          this.$refs.modalBox.classList.add('fadeOutDown');
          setTimeout(() => {
            this.$refs.modalBox.classList.add('fadeInUp');
            this.$refs.modalBox.classList.remove('fadeOutDown');
            this.$emit("back");
          }, 401);
        } else {
          this.$emit("back");
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";
@import "../scss/animate.css";
@import "../scss/components/btn.scss";

.top-bar {
  height: 64px;
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

@keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
@-webkit-keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
.animated {
  animation-duration: 0.4s !important;
  animation-iteration-count: 1 !important;
  animation-timing-function: ease-in !important;
  -webkit-animation-duration: 0.4s !important;
  -webkit-animation-iteration-count: 1 !important;
  -webkit-animation-timing-function: ease-in !important;
}
.fadeInUp {
  -webkit-animation-name: fadeInUp !important;
  animation-name: fadeInUp !important;
}


.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.modalbg {
  background: rgba(0, 0, 0, 0.60);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 120px auto 0px auto;
  z-index: 20;
  width: 85%;
  height: calc(100% - 120px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px 12px 0px 0px;
  opacity: 1;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 40px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete{
    display: flex;
    align-items: center;
    *:nth-child(n){
      margin-right: 20px;
    }
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: $color-secondary solid 2px;
    color: $color-secondary;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}

.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}
@-webkit-keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown !important;
  animation-name: fadeOutDown !important;
}

</style>
